import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (typeof control.value !== 'string') {
      return null
    }

    return control.value.trim().length === 0 ? { whitespace: true } : null
  }
}
